module.exports = __webpack_public_path__ + "static/media/map_placeholder.06d7256c.png";